import { useGetMailroomQuery } from '@api/mailroom';
import { useSettings } from '@hooks/useSettings';
import { MAILROOM_TIME_ZONE, PREFERRED_TIME_ZONE } from 'src/constants';

import { browserTimeZone } from '@utils/timeZones';
import { Mailroom } from 'src/types/apiContract';

const SETTING_NAMES = [PREFERRED_TIME_ZONE];

export const getTimeZone = (setting: string, mailroom?: Mailroom) => {
  if (setting === MAILROOM_TIME_ZONE && mailroom?.hoursOfOperation.timeZoneInfoId) {
    return mailroom.hoursOfOperation.timeZoneInfoId;
  }
  return browserTimeZone;
}

export const useDisplayTimeZone = () => {
  const { [PREFERRED_TIME_ZONE]: preference = '' } = useSettings(SETTING_NAMES) as Record<string, string>;
  const { data: mailroom, isLoading: isMailroomLoading } = useGetMailroomQuery();

  const mailroomTimeZone = mailroom?.hoursOfOperation.timeZoneInfoId || null;
  const isMailroomTimeZone = preference === MAILROOM_TIME_ZONE;

  return {
    timeZone: getTimeZone(preference, mailroom),
    isMailroomTimeZone,
    isResolving: isMailroomTimeZone && isMailroomLoading,
    browserTimeZone,
    mailroomTimeZone,
  };
};
